<template>
  <v-card class="mx-auto" outlined height="600">   
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline">
          {{ descrizione }}
        </div>
        <v-list-item-subtitle class="text--primary">{{sottotitolo}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>    
    <v-card-text class="pb-0">
      <v-simple-table dense class="mt-1">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">CODICE</th>
              <th class="text-left">DESCRIZIONE</th>
              <th class="text-left">LOTTO</th>
              <th class="text-left">UM</th>
              <th class="text-right">QUANTITA' CARICATA</th>
              <th class="text-right">QUANTITA' RESIDUA</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in prodotti" :key="index">
              <td class="text-left">{{ item.codice }}</td>
              <td class="text-left">{{ item.descrizione }}</td>
              <td class="text-left">{{ item.lotto }}</td>
              <td class="text-left">{{ item.unitaMisura }}</td>
              <td class="text-right">{{ item.quantita }}</td>
              <td class="text-right">{{ refresh && item.residuo !== undefined ? item.residuo : item.quantita }}</td>
              <td>
                <v-icon small class="mr-2" @click="editItem(item, index)">mdi-pencil</v-icon>
                <v-icon small class="mr-2" @click="deleteItem(item, index)">mdi-delete</v-icon>
              </td>
            </tr>
          </tbody>                
        </template>
      </v-simple-table>
    </v-card-text>
    <carica-temporaneo :showDialog="showDialog" :prodotto="editedItem" :trigger="trigger" @salvaProdotto="saveDialogProdotto" @registraCaloPeso="registraCaloPeso"/>
    <v-card-actions>
      <v-fab-transition>
        <v-btn color="pink" dark bottom absolute left fab small @click="addItem()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>        
    </v-card-actions>
  </v-card>
</template>

<script>
  import CaricaTemporaneo from './caricaTemporaneo'
  import prodotti from '@/services/prodottiService.js'
/*   import documenti from '@/services/documentiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import configurazioni from '@/services/configurazioniService.js' */

  export default {
    components: {
      CaricaTemporaneo
    },
    props: {
      magazzino: String,
      descrizione: String,
      sottotitolo: String,
      prodotti: Array,
      refresh: Number
    },
    data () {
      return {
        showDialog: false,
        editedIndex: -1,
        editedItem: {
          codice: '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 0
        },
        trigger: 1
        // locProdotti: []
      }
    },
    async mounted() {
      // this.locProdotti = this.prodotti
      // await this.verificaGiacenza()
    },
    watch: {
/*       prodotti(elenco) {
        this.locProdotti = elenco
      } */
/*       async refresh() {
        await this.verificaGiacenza()
      } */
    },
    methods: {
/*       async verificaGiacenza() {
        var that = this
        debugger
        let ids = this.locProdotti.map(x => x.id || x.codice)
        ids = _.uniq(ids)
        const elenco = await prodotti.getProdottiByIds(ids)
        for (let p of this.locProdotti) {
          let elP = elenco.find(x => x._id === (p.id || p.codice))
          let giacenza = _.get(elP, `magazzino.giacenzaParziale.${this.magazzino}.giacenza`)
          if (giacenza) {
            p.residuo = giacenza
          }
        }
      }, */
      async editItem(item) {
        this.editedIndex = this.prodotti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.trigger++
        await this.addItem()
      },
      deleteItem(item) {
        const answer = window.confirm('Confermi cancellazione ?')
        if (!answer) return false        
        const idx = this.prodotti.indexOf(item)
        this.prodotti.splice(idx, 1)
        this.$emit('deleteTemporaneo', this.magazzino, item)
      },
      async addItem() {
        this.showDialog = true
        await this.$nextTick()
        this.showDialog = false
      },
      async saveDialogProdotto(item) {
        const prodotto = {
          id: item.lotto.codiceProdotto,
          codice: item.codice,
          descrizione: item.descrizione,
          lotto: item.lotto.id,
          quantita: item.quantita,
          unitaMisura: item.unitaMisura,
          scadenza: item.lotto.scadenza
        }
        if (this.editedIndex === -1) {
          this.prodotti.push(prodotto)
        } else {
          this.prodotti[this.editedIndex] = prodotto
        }
        this.$emit('salvaTemporaneo', this.magazzino, prodotto)
      },
      registraCaloPeso(prodotto, delta) {
        this.$emit('registraCaloPeso', prodotto, delta)
      }
    }
  }
</script>
